import { gql } from '@apollo/client';

export const AI_PPV_CLIP_NOTES_FRAGMENT = gql`
  fragment AiPpvClipNotesFields on AiClipRecord {
    notes {
      clipName
      messages {
        id
        authorId
        authorName
        createdAt
        text
      }
    }
  }
`;

export const GET_STREAMS_WITH_PPV_CLIPS = gql`
  query GetStreamsWithPpvClips($input: StreamFilterInput) {
    adminStreams(input: $input) {
      entities {
        id
        slug
        name
        scheduleDate
        streamStatus
        isPPV
        store {
          id
          slug
          firstName
          lastName
          storeDetails {
            storeName
          }
        }
        # Only what the list columns render — the per-clip manifest and note threads are the
        # detail page's job and would be fetched for every row here.
        ppvClips {
          userId
          interviewId
          status
          clipsGenerated
          outputVideoCreatedAt
        }
      }
      total
      offset
      limit
    }
  }
`;

/** One record per source recording, in air-time order. Interrupted streams have several. */
export const GET_PPV_CLIPS = gql`
  query GetPpvClips($userSlug: String!, $streamSlug: String!) {
    getPpvClips(input: { userSlug: $userSlug, streamSlug: $streamSlug }) {
      userId
      interviewId
      streamRecordId
      jobId
      status
      profileName
      videoUrl
      inputVideoCreatedAt
      outputVideoCreatedAt
      outputBucket
      outputPrefix
      clipsGenerated
      errorMessage
      ...AiPpvClipNotesFields
      uploadedFileList {
        name
        s3Key
        url
        title
        topic
        score
      }
    }
  }
  ${AI_PPV_CLIP_NOTES_FRAGMENT}
`;

export const GET_PPV_CLIP_PRESIGNED_URL = gql`
  query GetPpvClipPresignedUrl($s3Uri: String!) {
    getPpvClipPresignedUrl(input: { s3Uri: $s3Uri })
  }
`;

export const ADD_PPV_CLIP_NOTE = gql`
  mutation AddPpvClipNote($input: AddAiClipNoteInput!) {
    addPpvClipNote(input: $input) {
      userId
      interviewId
      ...AiPpvClipNotesFields
    }
  }
  ${AI_PPV_CLIP_NOTES_FRAGMENT}
`;

export const UPDATE_PPV_CLIP_NOTES = gql`
  mutation UpdatePpvClipNotes($input: UpdateAiClipNotesInput!) {
    updatePpvClipNotes(input: $input) {
      userId
      interviewId
      ...AiPpvClipNotesFields
    }
  }
  ${AI_PPV_CLIP_NOTES_FRAGMENT}
`;
